import React from "react";
import { SimpleTextProps, SimpleText } from "../SimpleText";

export default (props: SimpleTextProps) => {
  return <SimpleText as="h2" fontSize="large" {...props} />;
};
